import styled, {keyframes} from 'styled-components';

const spinnerAnimationKeyframes = keyframes`
    0% {
        transform: rotate(0);
        animation-timing-function: cubic-bezier(.55, .055, .675, .19)
    }
    50% {
        transform: rotate(180deg);
        animation-timing-function: cubic-bezier(.215, .61, .355, 1)
    }
    to {
        transform: rotate(360deg)
    }
`;

export const SpinnerBackgroundDefaultBox = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -1063px -318px;
    animation: ${spinnerAnimationKeyframes} 1s infinite;
    image-rendering: pixelated;
    animation-direction: normal;
    animation-play-state: running;
    animation-duration: 1s;
    mix-blend-mode: screen;
`;